import Vue from 'vue'
import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect:'/index'
  },
  {
    path: '/index',
    component: ()=> import('../views/Home/index.vue')
  },
  {
    path: '/about',
    component: ()=> import('../views/About/index.vue')
  },
  {
    path: '/course',
    component: ()=> import('../views/Course/index.vue')
  },
  {
    path: '/musicList',
    component: ()=> import('../views/Music/index.vue')
  },
  {
    path: '/studyLoad',
    component: ()=> import('../views/Study/index.vue')
  },
  {
    path: '/shop',
    component: ()=> import('../views/Shop/index.vue')
  },
  {
    path: '/shopInfo',
    component: ()=> import('../views/Shop/info.vue')
  },
  {
    path: '/piano',
    component: ()=> import('../views/Piano/index.vue')
  },
  {
    path: '/pianoInfo',
    component: ()=> import('../views/Piano/info.vue')
  }
]

const router = new VueRouter({
  mode: 'hash', 
  routes,
  scrollBehavior() { 
    return { x: 0, y: 0 } 
  }, 
})


export default router